// eslint-disable-next-line no-shadow
export enum NsType {
  All = "A",       // A: Lấy tất cả thông báo
  Personal = "U",  // U: Cá nhân
  PromoSystem = "S", // S: Thông báo hệ thống + Khuyến mãi
  News = "N",      // N: Thông báo tin tức
  Private = "P",   // P: Riêng tư (U+S combined) — dùng cho getNotificationSticky
}
